module.exports = __webpack_public_path__ + "media/2.b9a64a4a.mp3";